import type {
  RouteLocationNormalized,
  RouteRecordRaw,
  RouteRecordName,
  RouteParams,
  RouteQueryAndHash
} from "vue-router";

import ScenarioDetail from "@/views/scenarios/ScenarioDetail.vue";
import WellInfo from "@/views/scenarios/WellInfo.vue";
import SizingParameters from "@/views/scenarios/SizingParameters.vue";
import PerformanceEvaluation from "@/views/scenarios/PerformanceEvaluation.vue";
import ScenarioInfo from "@/views/scenarios/ScenarioInfo.vue";
import ScenarioSchematic from "@/views/scenarios/ScenarioSchematic.vue";
import ScenarioAnalysis from "@/views/ScenarioAnalysis.vue";

export type ScenarioRouteParams = {
  sizingId: string | null;
  scenarioId: string | null;
  perfevalId: string | null;
  routeName?: RouteRecordName | null | undefined;
  routeParams?: RouteParams;
  routeQuery?: RouteQueryAndHash;
};

export const propify = (
  route: RouteLocationNormalized
): ScenarioRouteParams => ({
  perfevalId: Array.isArray(route.params.perfevalId)
    ? route.params.perfevalId[0]
    : route.params.perfevalId || "new",
  scenarioId: Array.isArray(route.params.scenarioId)
    ? route.params.scenarioId[0]
    : route.params.scenarioId || "new",
  sizingId: Array.isArray(route.params.sizingId)
    ? route.params.sizingId[0]
    : route.params.sizingId || "new",
  routeName: route.name,
  routeParams: route.params,
  routeQuery: route.query
});

const childRoutes = [
  {
    path: "well",
    name: "WellInfo",
    component: WellInfo,
    props: propify,
    meta: {
      title: "Well Information",
      requiresAuth: true
    }
  },
  {
    path: "params",
    name: "SizingParameters",
    component: SizingParameters,
    props: propify,
    meta: {
      title: "Sizing Parameters",
      requiresAuth: true
    }
  },
  {
    path: "info",
    name: "ScenarioInfo",
    component: ScenarioInfo,
    props: propify,
    meta: {
      title: "Scenario Information",
      requiresAuth: true
    }
  },
  {
    path: "schematic",
    name: "ScenarioSchematic",
    component: ScenarioSchematic,
    meta: {
      title: "Scenario Schematic",
      requiresAuth: true
    }
  },
  {
    path: "perfeval",
    name: "PerformanceEvaluations",
    component: PerformanceEvaluation,
    props: propify,
    meta: {
      title: "Performance Evaluations",
      requiresAuth: true
    }
  },
  {
    path: "analysis",
    name: "ScenarioAnalysis",
    component: ScenarioAnalysis,
    props: (route: RouteLocationNormalized) => ({
      ...propify(route),
      reactive: true
    }),
    meta: {
      title: "Scenario Analysis",
      requiresAuth: true
    }
  },
  {
    path: "perfeval/:perfevalId",
    name: "PerformanceEvaluation",
    component: PerformanceEvaluation,
    props: propify,
    meta: {
      title: "Performance Evaluations",
      requiresAuth: true
    }
  }
];

const scenariosRoutes: Array<RouteRecordRaw> = [
  {
    path: "scenarios",
    name: "Scenarios",
    component: ScenarioDetail,
    props: propify,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "scenarios/:scenarioId",
    name: "Scenario",
    component: ScenarioDetail,
    props: propify,
    meta: { requiresAuth: true },
    children: childRoutes
  }
];

export default scenariosRoutes;
